import { keys, forEach } from 'lodash';
import { isEmptyVal, noopPromise } from '@/utils';
import { billingConfig$Cache } from '@/common/service/common';
import { dateTimeFormat } from '@/utils/dateformat';
import { translation } from '@/plugins/i18n';

const state = {
  basicConfig: {
    hasPendingCoupon: false,
    pendingCouponEffectiveDate: null,
    allowMonthly2Annual: false,
    hasPendingPlans: false,
    couponExpireDate: null,
    canSelectBiz: false,
    canSelectBizPlus: false,
    isBulkLicenseAccount: false,
    isSMBCustomer: false,
    freeStorage: false,
    bizCanDowngrade: true,
    isCustomPricing4MajorPlan: false,
    canSelectProPlus: true,
    ZCMDefaultStorage: null,
    downSellData: {
      disableDownSell: false,
      mrs: undefined,
      currentTerm: undefined,
      renewalTerm: undefined,
      subscriptionEndDate: undefined,
      currentTermPeriodType: undefined,
      renewalTermPeriodType: undefined,
    }
  },
  successConfig: {
    eligibleProductTypeJson: []
  }
};

const getters = {
  basicConfig: (state) => state.basicConfig,
  disableMonthly2AnnualTip(state, getters) {
    const { allowMonthly2Annual, hasPendingPlans, couponExpireDate } = getters.basicConfig || {};

    if (allowMonthly2Annual) {
      if (hasPendingPlans) {
        return translation('billing.error.has_pending_plans_change_tips');
      } else if (!isEmptyVal(couponExpireDate)) {
        const date = dateTimeFormat(couponExpireDate);
        return translation('billing.error.has_time_based_discount_change_tips', [date]);
      }
    }

    return '';
  },
  successConfig: (state) => state.successConfig,
};

const mutations = {
  setBasicConfig(state, data = {}) {
    forEach(keys(data), (key) => {
      state.basicConfig[key] = data[key];
    });
  },
  setSuccessConfig(state, data = {}) {
    forEach(keys(data), (key) => {
      state.successConfig[key] = data[key];
    });
  },
};

const actions = {
  async getBasicConfig({ commit }) {
    const isLoggedIn = window.$context?.is?.loggedIn;
    const fetchConfigApi = isLoggedIn ? billingConfig$Cache : noopPromise;
    const { result } = (await fetchConfigApi() || {});
    commit('setBasicConfig', result);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
